<template>
    <div class="homePage">
        <div class="homePageLeft">
            <Aside></Aside>
        </div>
        <div class="homePageRight">
            <div class="pageTop">
                <Header></Header>
            </div>
            <div class="main">
                <transition name="el-fade-in-linear">
                    <router-view></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'homePage',

    data() {
        return {
            isShow: true
        };
    },
    components: {
        Aside: () => import('@/components/aside.vue'),
        Header: () => import('@/components/header.vue')
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped>
.homePage {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: rgb(240, 240, 240);
    .homePageLeft {
        // width: 300px;
        height: 100%;
    }
    .homePageRight {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
    .main {
        width: 100%;
        height: calc(100% - 40px);
        padding: 20px;
        box-sizing: border-box;
        overflow-x: hidden;
        // display: flex;
        // flex-direction: column;
        // justify-content: space-between;
        // align-items: center;
    }
}
</style>